import React from 'react';
import { motion } from 'motion/react';

interface OnboardingPillProps {
  label: string;
  selected: boolean;
  index: number;
  onClick: () => void;
}

const OnboardingPill: React.FC<OnboardingPillProps> = ({ label, selected, index, onClick }) => {
  return (
    <motion.button
      type="button"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay: 0.25 + index * 0.05, ease: [0.25, 0.46, 0.45, 0.94] }}
      whileTap={{ scale: 0.95 }}
      onClick={onClick}
      className={`px-4 py-2 rounded-full border text-sm transition-colors duration-200 cursor-pointer focus:outline-none ${
        selected
          ? 'bg-[#7c6cf6]/20 border-[#7c6cf6] text-[#7c6cf6]'
          : 'bg-white/5 border-white/10 text-white/70 hover:border-white/30 hover:text-white'
      }`}>
      {label}
    </motion.button>
  );
};

export default OnboardingPill;
